import {
	Home,
	SettingsSuggest,
	BusinessCenter,
	School,
	Mail,
	AcUnit
} from "@mui/icons-material";

export const navItem = [
	{ id: 1, name: "HOME", link: "welcome", icon: Home },
	{ id: 2, name: "SKILL", link: "skill", icon: SettingsSuggest },
	{ id: 3, name: "PROFICIENCY", link: "proficiency", icon: AcUnit },
	{ id: 4, name: "EDUCATION", link: "education", icon: School },
	{ id: 5, name: "PROJECTS", link: "projects", icon: BusinessCenter },
	{ id: 6, name: "CONTACT", link: "contact", icon: Mail }
];
